import { createSlice } from "@reduxjs/toolkit";
import { STOCKOUT_SUMMARY_COLUMNS } from "../../components/stockout-summary/card/stockout-summary.columns";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  filters: {},
  visibleColumns: STOCKOUT_SUMMARY_COLUMNS.map((col) => [col.key, true]),
  itemPerPage: 25,
  page: 0,
  total: 0,
  start: 0,
  length: 0,
  filteredCount: 0,
  draw: 0,
};

const stockoutSummarySlice = createSlice({
  name: "stockoutSummary",
  initialState,
  reducers: {
    fetchStockoutSummaryStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchStockoutSummarySuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.data;
      state.total = action.payload.total || 0;
      state.start = action.payload.start ?? state.start;
      state.length = action.payload.length ?? state.length;
      state.filteredCount = action.payload.filteredCount ?? state.filteredCount;
      state.draw = action.payload.draw ?? state.draw;
    },
    fetchStockoutSummaryFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setFilters(state, action) {
      state.filters = action.payload;
    },
    setVisibleColumns(state, action) {
      state.visibleColumns = action.payload;
    },
    setItemPerPage(state, action) {
      state.itemPerPage = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
  },
});

export const {
  fetchStockoutSummaryStart,
  fetchStockoutSummarySuccess,
  fetchStockoutSummaryFailure,
  setFilters,
  setVisibleColumns,
  setItemPerPage,
  setPage,
} = stockoutSummarySlice.actions;

export default stockoutSummarySlice.reducer;
